define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def/Action",
    "csi/def/ViewRef",
    "csi/heading/RefContainer",
    "csi/locale",
    "csi/xml",
    "csi/xml/Query"
], function(declare,lang,Action,ViewRef,RefContainer,locale,xml,Query) {

    return declare(RefContainer, {
        _getProductUrl: function(/*Context*/ctx) {
            // summary: Return URL of the IssueProduct
            var issueLog;
            if (ctx != null) {
                issueLog = ctx.getNodeParent();
            }
            return (issueLog && xml.isValidURL(issueLog.IssueProduct)) ? issueLog.IssueProduct : null;
        },

    	_getPriorityStoreAction: function(/*Context*/ctx, /*Heading*/h) {
            // summary: return priority select action for Issue.IssueProductColors
            var productUrl = this._getProductUrl(ctx);
            if (!productUrl)
            	return null;

            return lang.mixin(new Action(), {
            	// set urlContext to guarantee different keys for priority and non-priority action and thus two queries will be sent
                urlContext: ctx.getNodeURL(),
                m_fixedQuery: new Query().Attr("Active", xml.OP_EQUALS, "true"),
                m_viewRef: lang.mixin(new ViewRef(), {
                    m_id: "ProductColors",
                    m_url: productUrl
                })
            });
        },

        getStoreOptions: function(/*Context*/ctx, /*Heading*/h) {
            // S11075 summary: on Style Issue creation, add Colorway Code after ProductColor Name
            var productUrl = this._getProductUrl(ctx);
            // "true" on getNode() is only needed for the create form
            var product = productUrl ? ctx.cache.getNode(productUrl, true) : null;
            if (!product || product.$Type != "Style") // Could be material
                return this.inherited(arguments);

            return {
                customOperation: true,
                _processResultNode: function(/*Node*/node, /*Cache*/cache) {
                    //S11075 summary: add Colorway Code after ProductColor Name
                    var origName = node.$Name || locale.resource("NAME_EMPTY");
                    return {$:node.$URL, Name:origName + " " + node.Code, node:node};
                }
            }
        }
    });
});